import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';

import MainHeader from './mainHeader';

const personalDataHeaderPages = [
    { path: "/cribis", translateKey: "Cribis" },
    { path: "/gdpr", translateKey: "GDPR" },
    { path: "/cookies", translateKey: "Cookies" }
];

class PersonalDataHeader extends React.Component {
    render() {
        return (
            <>
                <MainHeader label="Footer.PersonalData" shadowed={false} {...this.props} />
                {!this.props.isMobile && <div className={classnames('tabs tabs-subheader shadowed', { 'tinted': this.props.tinted })}>
                    <ul style={{ border: "none" }}>
                        {(personalDataHeaderPages).map(page =>
                            <li key={page.translateKey} className={`tab-link ${this.isActiveLink(page.path) ? 'is-active' : ''}`}>
                                <NavLink to={`${this.props.match.url}${page.path}`} >
                                    <Translate id={`PersonalData.${page.translateKey}`} />
                                </NavLink>
                                <div className="search-progress-short" style={{ display: this.isActiveLink(page.path) ? "" : "none" }}></div>
                            </li>
                        )}
                    </ul>
                </div>}
            </>
        );
    }

    isActiveLink = (item) => this.props.location.pathname.indexOf(item) >= 0;
}

export default withRouter(connect(state => ({ ...state, search: state.search }))(PersonalDataHeader));